// src/dashboard/Paginas/Gateways.jsx
import { useEffect, useState } from 'react';
import axios from 'axios';
import '../styles/gateways-admin.css';

export default function GatewaysAdmin() {
  const [loading, setLoading] = useState(true);
  const [active, setActive] = useState({
    pix: 'mercado_pago',
    cartao: 'mercado_pago',
    boleto: 'mercado_pago',
  });
  const [mp, setMp] = useState({
    access_token: '',
    public_key: '',
    webhook_secret: '',
  });
  const [appmax, setAppmax] = useState({
    token: '',
    api_url: '',
  });
  const [pixManual, setPixManual] = useState({
    enabled: false,
    chave: '',
    favorecido: '',
    banco: '',
    whatsappDestino: '',
  });
  const [pixWhatsapp, setPixWhatsapp] = useState(true);
  // ▼ NOVO: credenciais da Asaas
  const [asaas, setAsaas] = useState({ access_token: '', environment: 'sandbox', webhook_token: '', addressKey: '' })
  const [webhooksInfo, setWebhooksInfo] = useState({ urls: {}, secrets: {} })
  const [pagarme, setPagarme] = useState({ secret_key: '', public_key: '', webhook_secret: '' })
  const [cartaoManual, setCartaoManual] = useState({ whatsappDestino: '' })
  const [infinitepay, setInfinitepay] = useState({ handle: 'ticket-do-vaqueiro' })


  const API = process.env.REACT_APP_API_URL;

useEffect(() => {
  (async () => {
    try {
      const [{ data: cfg }, { data: info }] = await Promise.all([
        axios.get(`${API}/gateways`),
        axios.get(`${API}/gateways/webhooks-info`),
      ]);
      setActive({
        pix: cfg.activePixProvider || 'mercado_pago',
        cartao: cfg.activeCardProvider || 'mercado_pago',
        boleto: cfg.activeBoletoProvider || 'mercado_pago',
      });
      setMp(cfg.credentials?.mercado_pago || { access_token: '', public_key: '', webhook_secret: '' });
      setAppmax(cfg.credentials?.appmax || { token: '', api_url: '' });
      setPixManual(cfg.credentials?.pix_manual || { enabled: false, chave: '', favorecido: '', banco: '', whatsappDestino: '' });
      setCartaoManual(cfg.credentials?.cartao_manual || { whatsappDestino: '' })
      setAsaas(cfg.credentials?.asaas || { access_token: '', environment: 'sandbox', webhook_token: '', addressKey: '' });
      setPagarme(cfg.credentials?.pagarme || { secret_key: '', public_key: '', webhook_secret: '' });
      setInfinitepay(cfg.credentials?.infinitepay || { handle: 'ticket-do-vaqueiro' });
      setWebhooksInfo(info || { urls: {}, secrets: {} });
    } catch (e) {
      console.warn('Falha ao carregar gateways/webhooks-info', e);
    } finally {
      setLoading(false);
    }
  })();
}, [API]);


  const salvarProvedores = async () => {
    try {
      await axios.put(`${API}/gateways/activate`, {
        pix: active.pix,
        cartao: active.cartao,
        boleto: active.boleto,
      });
      alert('Provedores atualizados.');
    } catch (e) {
      console.error(e);
      alert('Erro ao salvar provedores.');
    }
  };

  const salvarCredenciais = async () => {
    try {
      await axios.put(`${API}/gateways/credentials`, {
        mercado_pago: mp,
        appmax: appmax,
        pix_manual: pixManual,
        asaas,
        pagarme,
        cartao_manual: cartaoManual,
        infinitepay,
      });
      alert('Credenciais salvas.');
    } catch (e) {
      console.error(e);
      alert('Erro ao salvar credenciais.');
    }
  };

  const salvarWebhooks = async () => {
  try {
    await axios.put(`${API}/gateways/webhooks`, {
      mercado_pago: { webhook_secret: mp.webhook_secret || '' },
      appmax:       { webhook_secret: appmax.webhook_secret || '' },
      asaas:        { webhook_token:  asaas.webhook_token  || '' },
      pagarme:      { webhook_secret:  pagarme.webhook_secret || '' },
    });
    const { data } = await axios.get(`${API}/gateways/webhooks-info`);
    setWebhooksInfo(data || { urls: {}, secrets: {} });
    alert('Webhooks salvos.');
  } catch (e) {
    console.error(e);
    alert('Erro ao salvar webhooks.');
  }
};


  if (loading) return <div className="gatew-container"><p>Carregando…</p></div>;

  return (
    <div className="gatew-container">
      <h2 className="gatew-header">Gateways</h2>

      {/* Seção: Provedores Ativos */}
      <div className="gatew-section">
        <h3>Ativar provedores</h3>
        <div className="gatew-providers">
          <div className="gatew-field">
            <label className="gatew-label">Pix</label>
            <select
              className="gatew-select"
              value={active.pix}
              onChange={(e) => setActive((a) => ({ ...a, pix: e.target.value }))}
            >
              <option value="mercado_pago">Mercado Pago</option>
              <option value="appmax">Appmax</option>
              <option value="pix_manual">Pix Manual</option>
              <option value="asaas">Asaas</option>
              <option value="pagarme">Pagar.me</option>

            </select>
          </div>

          <div className="gatew-field">
            <label className="gatew-label">Cartão</label>
            <select
              className="gatew-select"
              value={active.cartao}
              onChange={(e) => setActive((a) => ({ ...a, cartao: e.target.value }))}
            >
              <option value="mercado_pago">Mercado Pago</option>
              <option value="cartao_manual">Cartão Manual</option>
              <option value="infinitepay">InfinitePay</option>
            </select>
          </div>

          <div className="gatew-field">
            <label className="gatew-label">Boleto</label>
            <select
              className="gatew-select"
              value={active.boleto}
              onChange={(e) => setActive((a) => ({ ...a, boleto: e.target.value }))}
            >
              <option value="mercado_pago">Mercado Pago</option>
              <option value="asaas">Asaas</option>
            </select>
          </div>
        </div>

        <div className="gatew-actions">
          <button className="gatew-button" onClick={salvarProvedores}>
            Salvar provedores
          </button>
        </div>
      </div>

      {/* Seção: Credenciais MP */}
      <div className="gatew-section">
        <h3>Credenciais – Mercado Pago</h3>
        <div className="gatew-grid gatew-grid-full">
          <div className="gatew-field">
            <label className="gatew-label">ACCESS_TOKEN</label>
            <input
              className="gatew-input"
              placeholder="ACCESS_TOKEN"
              value={mp.access_token || ''}
              onChange={(e) => setMp({ ...mp, access_token: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">PUBLIC_KEY</label>
            <input
              className="gatew-input"
              placeholder="PUBLIC_KEY"
              value={mp.public_key || ''}
              onChange={(e) => setMp({ ...mp, public_key: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">WEBHOOK_SECRET</label>
            <input
              className="gatew-input"
              placeholder="WEBHOOK_SECRET"
              value={mp.webhook_secret || ''}
              onChange={(e) => setMp({ ...mp, webhook_secret: e.target.value })}
            />
          </div>
        </div>
      </div>

      {/* Seção: Credenciais Appmax */}
      <div className="gatew-section">
        <h3>Credenciais – Appmax</h3>
        <div className="gatew-grid">
          <div className="gatew-field">
            <label className="gatew-label">TOKEN</label>
            <input
              className="gatew-input"
              placeholder="TOKEN"
              value={appmax.token || ''}
              onChange={(e) => setAppmax({ ...appmax, token: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">API URL</label>
            <input
              className="gatew-input"
              placeholder="https://admin.appmax.com.br/api/v3"
              value={appmax.api_url || ''}
              onChange={(e) => setAppmax({ ...appmax, api_url: e.target.value })}
            />
          </div>
        </div>
      </div>
      <div className="gatew-section">
  <h3>Credenciais – Pagar.me</h3>
  <div className="gatew-grid">
    <div className="gatew-field">
      <label className="gatew-label">SECRET_KEY (sk_*/sk_test_*)</label>
      <input className="gatew-input" value={pagarme.secret_key || ''} onChange={e => setPagarme({ ...pagarme, secret_key: e.target.value })} />
    </div>
    <div className="gatew-field">
      <label className="gatew-label">PUBLIC_KEY (pk_*/pk_test_*)</label>
      <input className="gatew-input" value={pagarme.public_key || ''} onChange={e => setPagarme({ ...pagarme, public_key: e.target.value })} />
    </div>
    <div className="gatew-field">
      <label className="gatew-label">Webhook Secret (opcional)</label>
      <input className="gatew-input" value={pagarme.webhook_secret || ''} onChange={e => setPagarme({ ...pagarme, webhook_secret: e.target.value })} />
    </div>
  </div>
  <div className="gatew-actions">
    <button className="gatew-button" onClick={salvarCredenciais}>Salvar credenciais</button>
  </div>
</div>

<div className="gatew-section">
  <h3>Credenciais – InfinitePay</h3>
  <div className="gatew-grid">
    <div className="gatew-field">
      <label className="gatew-label">InfiniteTag / handle</label>
      <input
        className="gatew-input"
        value={infinitepay.handle || ''}
        onChange={(e) => setInfinitepay({ ...infinitepay, handle: e.target.value.replace(/^\$+/, '') })}
        placeholder="ticket-do-vaqueiro"
      />
      <small style={{ color: '#b0b0b0' }}>Informe sem o símbolo $. O checkout da InfinitePay é aberto ao cliente em uma página segura.</small>
      <small style={{ display: 'block', marginTop: 8, color: '#b54708' }}>O checkout integrado pode oferecer Pix e cartão conforme a configuração da conta. Antes de ativar, confirme que somente cartão está disponível para esse checkout; pagamentos recebidos por Pix não serão baixados como cartão.</small>
    </div>
  </div>
  <div className="gatew-actions">
    <button className="gatew-button" onClick={salvarCredenciais}>Salvar credenciais</button>
  </div>
</div>
{/* Seção: Credenciais – Asaas */}
<div className="gatew-section">
  <h3>Credenciais – Asaas</h3>
  <div className="gatew-grid">
    <div className="gatew-field">
      <label className="gatew-label">Access Token</label>
      <input
        className="gatew-input"
        type="text"
        value={asaas.access_token || ""}
        onChange={(e) => setAsaas(prev => ({ ...prev, access_token: e.target.value }))}
        placeholder="Cole o token da Asaas"
      />
    </div>
    <div className="gatew-field">
      <label className="gatew-label">Pix AddressKey</label>
      <input
        className="gatew-input"
        type="text"
        value={asaas.addressKey || ""}
        onChange={(e) => setAsaas(prev => ({ ...prev, addressKey: e.target.value }))}
        placeholder="Cole a chave Pix (addressKey) da Asaas"
      />
    </div>
    <div className="gatew-field">
      <label className="gatew-label">Ambiente</label>
      <select
        className="gatew-select"
        value={asaas.environment || "sandbox"}
        onChange={(e) => setAsaas(prev => ({ ...prev, environment: e.target.value }))}
      >
        <option value="sandbox">Sandbox</option>
        <option value="production">Produção</option>
      </select>
    </div>
  </div>

  <div className="gatew-actions">
    <button className="gatew-button" onClick={salvarCredenciais}>
      Salvar credenciais
    </button>
  </div>
</div>



      {/* Seção: Pix Manual */}
      <div className="gatew-section">
        <h3>Pix Manual</h3>
        <div className="gatew-grid gatew-grid-full" style={{ marginBottom: 8 }}>
          <label className="gatew-checkbox">
            <input
              type="checkbox"
              checked={!!pixManual.enabled}
              onChange={(e) => setPixManual({ ...pixManual, enabled: e.target.checked })}
            />
            Habilitar Pix Manual
          </label>
        </div>

        <div className="gatew-grid">
          <div className="gatew-field">
            <label className="gatew-label">Chave Pix</label>
            <input
              className="gatew-input"
              placeholder="Chave Pix"
              value={pixManual.chave || ''}
              onChange={(e) => setPixManual({ ...pixManual, chave: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">Favorecido</label>
            <input
              className="gatew-input"
              placeholder="Favorecido"
              value={pixManual.favorecido || ''}
              onChange={(e) => setPixManual({ ...pixManual, favorecido: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">Banco</label>
            <input
              className="gatew-input"
              placeholder="Banco"
              value={pixManual.banco || ''}
              onChange={(e) => setPixManual({ ...pixManual, banco: e.target.value })}
            />
          </div>

          <div className="gatew-field">
            <label className="gatew-label">WhatsApp destino (opcional)</label>
            <input
              className="gatew-input"
              placeholder="Ex.: 5583999999999"
              value={pixManual.whatsappDestino || ''}
              onChange={(e) => setPixManual({ ...pixManual, whatsappDestino: e.target.value })}
            />
          </div>
        </div>




        <div className="gatew-actions">
          <button className="gatew-button" onClick={salvarCredenciais}>
            Salvar credenciais
          </button>
        </div>

      </div>
      {/* Seção: Pix via WhatsApp */}
<div className="gatew-section">
  <h3>Pix via WhatsApp</h3>
  <div className="gatew-grid gatew-grid-full" style={{ marginBottom: 8 }}>
    <label className="gatew-checkbox">
      <input
        type="checkbox"
        checked={pixWhatsapp}
        onChange={(e) => setPixWhatsapp(e.target.checked)}
      />
      Habilitar envio automático de Pix no WhatsApp
    </label>
  </div>
  <div className="gatew-actions">
    <button
      className="gatew-button"
      onClick={async () => {
        try {
          await axios.post(`${API}/pagamento/config/pix-whatsapp`, { ativo: pixWhatsapp });
          alert("Configuração salva!");
        } catch (err) {
          alert("Erro ao salvar configuração.");
        }
      }}
    >
      Salvar
    </button>
  </div>
</div>

      {/* Seção: Cartão Manual */}
<div className="gatew-section">
  <h3>Cartão Manual</h3>
  <div className="gatew-grid">
    <div className="gatew-field">
      <label className="gatew-label">WhatsApp destino</label>
      <input
        className="gatew-input"
        placeholder="Ex.: 5583999999999 (só números)"
        value={cartaoManual.whatsappDestino || ""}
        onChange={(e) =>
          setCartaoManual({ ...cartaoManual, whatsappDestino: e.target.value })
        }
      />
    </div>
  </div>
  <small style={{ color: "#b0b0b0" }}>
    Esse número receberá o pedido para gerar o link de pagamento via cartão.
  </small>
  <div className="gatew-actions" style={{ marginTop: 12 }}>
  <button className="gatew-button" onClick={salvarCredenciais}>
    Salvar credenciais
  </button>
</div>

</div>

              {/* Seção: Webhooks */}
<div className="gatew-section">
  <h3>Webhooks</h3>

  <div className="gatew-grid gatew-grid-full">
    {/* URLs */}
    <div className="gatew-field">
      <label className="gatew-label">URL – Mercado Pago</label>
      <div className="gatew-copy-row">
        <input className="gatew-input gatew-mono" readOnly value={webhooksInfo?.urls?.mercado_pago || ''} />
        <button className="gatew-button" onClick={() => navigator.clipboard.writeText(webhooksInfo?.urls?.mercado_pago || '')}>Copiar</button>
      </div>
    </div>

    <div className="gatew-field">
      <label className="gatew-label">URL – Appmax</label>
      <div className="gatew-copy-row">
        <input className="gatew-input gatew-mono" readOnly value={webhooksInfo?.urls?.appmax || ''} />
        <button className="gatew-button" onClick={() => navigator.clipboard.writeText(webhooksInfo?.urls?.appmax || '')}>Copiar</button>
      </div>
    </div>

    <div className="gatew-field">
      <label className="gatew-label">URL – Asaas</label>
      <div className="gatew-copy-row">
        <input className="gatew-input gatew-mono" readOnly value={webhooksInfo?.urls?.asaas || ''} />
        <button className="gatew-button" onClick={() => navigator.clipboard.writeText(webhooksInfo?.urls?.asaas || '')}>Copiar</button>
      </div>
    </div>

    <div className="gatew-field">
     <label className="gatew-label">URL – Pagar.me</label>
     <div className="gatew-copy-row">
       <input className="gatew-input gatew-mono" readOnly value={webhooksInfo?.urls?.pagarme || ''} />
       <button className="gatew-button" onClick={() => navigator.clipboard.writeText(webhooksInfo?.urls?.pagarme || '')}>Copiar</button>
     </div>
   </div>

   <div className="gatew-field">
     <label className="gatew-label">URL – InfinitePay</label>
     <div className="gatew-copy-row">
       <input className="gatew-input gatew-mono" readOnly value={webhooksInfo?.urls?.infinitepay || ''} />
       <button className="gatew-button" onClick={() => navigator.clipboard.writeText(webhooksInfo?.urls?.infinitepay || '')}>Copiar</button>
     </div>
     <small style={{ color: '#b0b0b0' }}>A confirmação é validada no servidor pela API de consulta da InfinitePay.</small>
   </div>

    {/* Segredos / Tokens */}
    <div className="gatew-field">
      <label className="gatew-label">Webhook Secret – Mercado Pago</label>
      <input
        className="gatew-input"
        placeholder="WEBHOOK_SECRET do MP"
        value={mp.webhook_secret || ''}
        onChange={(e) => setMp({ ...mp, webhook_secret: e.target.value })}
      />
      <small style={{ color: '#b0b0b0' }}>Atual: {webhooksInfo?.secrets?.mercado_pago || '—'}</small>
    </div>

    <div className="gatew-field">
      <label className="gatew-label">Webhook Secret – Appmax (opcional)</label>
      <input
        className="gatew-input"
        placeholder="Defina um segredo para validar o header da Appmax (se usar)"
        value={appmax.webhook_secret || ''}
        onChange={(e) => setAppmax({ ...appmax, webhook_secret: e.target.value })}
      />
      <small style={{ color: '#b0b0b0' }}>Atual: {webhooksInfo?.secrets?.appmax || '—'}</small>
    </div>

    <div className="gatew-field">
     <label className="gatew-label">Webhook Secret – Pagar.me</label>
     <input className="gatew-input" placeholder="Segredo configurado no Dashboard Pagar.me" value={pagarme.webhook_secret || ''} onChange={(e) => setPagarme({ ...pagarme, webhook_secret: e.target.value })} />
     <small style={{ color: '#b0b0b0' }}>Atual: {webhooksInfo?.secrets?.pagarme || '—'}</small>
    </div>

    <div className="gatew-field">
      <label className="gatew-label">Webhook Token – Asaas (header: asaas-access-token)</label>
      <input
        className="gatew-input"
        placeholder="Cole o token de autenticação do webhook da Asaas"
        value={asaas.webhook_token || ''}
        onChange={(e) => setAsaas(prev => ({ ...prev, webhook_token: e.target.value }))}
      />
      <small style={{ color: '#b0b0b0' }}>Atual (mascarado): {webhooksInfo?.secrets?.asaas || '—'}</small>
    </div>
  </div>

  <div className="gatew-actions">
    <button className="gatew-button" onClick={salvarWebhooks}>
      Salvar webhooks
    </button>
  </div>
</div>

    </div>
  );
}
